<template lang="html">
  <div class="centerx" style="min-width: 800px;">
    <vs-popup :title= "societyName?societyName + ' - ':'' + 'Historique des tâches'" :active.sync="isPopupActive" style="z-index: 99999;">
      <div class="container-fluid" >
        <div class="vx-row w-full">
          <!--<div class="vx-col">
            <vs-input class="inputx" placeholder="N° Contrat" v-model="contractNumberFilter" />
          </div>-->
          <div class="vx-col">
            <vs-select
                v-model="taskFilter"
                class="w-full select-medium mr-2"
                placeholder="Tâche"
                autocomplete
            >
              <vs-select-item
                value=""
                text="Toutes les tâches"
                class="w-full"
              />
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.short_description"
                v-for="(item, index) in missionsProduct"
                class="w-full"
              />
            </vs-select>
          </div>
		  <div class="vx-col px-1 mb-2">
				<vs-select
					v-model="statusFilter"
					class="w-full select-large"
					placeholder="Statut (Sélection multiple)"
					multiple
					autocomplete
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in taskStatusOptions"
						class="w-full"
					/>
				</vs-select>
			</div>
        </div>
        <vs-table :data="displayedTasks" class="mt-4" stripe :key="refreshTable">
          <template slot="thead">
			<vs-th sort-key="contract_id">N° Prestation</vs-th>
            <vs-th sort-key="contract_id" class="pdl0">N° Contrat</vs-th>
            <vs-th sort-key="mission_id" class="pdl0">Tâche</vs-th>
            <vs-th sort-key="commentary" class="pdl0">Commentaire</vs-th>
            <vs-th sort-key="commentary" class="pdl0">Consultants</vs-th>
            <vs-th sort-key="link" class="pdl0">Lien</vs-th>
            <vs-th sort-key="creation_date" class="pdl0">Date de création</vs-th>
            <vs-th sort-key="finished_date" class="pdl0">Date d'achèvement</vs-th>
            <vs-th sort-key="archivate">Statut</vs-th>
            <vs-th></vs-th>
            <vs-th v-if="$acl.check('sadmin')"></vs-th>
          </template>

          <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(task, index) in data">
		<vs-td class="pdl0 text-center">{{ task.number }}</vs-td>
		<vs-td>{{ task.contract_id }}</vs-td>
		<vs-td>{{
			task.mission_id ? getMissionProduct(task.mission_id) : task.commentary
		}}</vs-td>
		<vs-td>{{ task.commentary }}</vs-td>
		<vs-td
			><div class="flex center" style="justify-content: center">
				<!--  <vs-avatar style="border: 1px solid;" :text="data[index].commercial_name" :src="getCollaboratorAvatar(data[index].commercial_id)"/>  -->
				<vx-tooltip :text="task.consultant_name" position="top">
					<vs-avatar
						style="border: 1px solid"
						:text="task.consultant_name"
						:src="getCollaboratorAvatar(task.task_user_id)"
					/>
				</vx-tooltip></div
		></vs-td>
		<vs-td>{{ task.link }}</vs-td>
		<vs-td>
			{{ getDateToFrenchFormat(task.creation_date.substring(0, 10)) }}
		</vs-td>
		<vs-td>
			{{
				task.finished_date
					? getDateToFrenchFormat(task.finished_date.substring(0, 10))
					: " "
			}}
		</vs-td>
		<vs-td>
			<SliderWith3btn
				:id1="task.id + 'offcard'"
				:id2="task.id + 'nullcard'"
				:id3="task.id + 'oncard'"
				:value="task.archivate"
				styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78); width: 165px;"
				styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
				styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
				styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
				styleDefault="color: black;"
				option1="Annulé"
				option2="À faire"
				option3="Fait"
				@btn-selected="updateTask(task, $event)"
			/>
		</vs-td>
		<!-- <vs-td v-if="!task.mission_id">
                    <vx-tooltip text="Modifier" position="top">
                    <vs-button
                        size="large"
                        color="primary"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        @click="updateTask(task)"
                    ></vs-button>
                    </vx-tooltip>
                </vs-td>     -->
		<vs-td v-if="$acl.check('accountmanager') && task.document_count <= 0">
			<vx-tooltip text="Ajouter un lien" position="top">
				<vs-button
					size="large"
					color="primary"
					type="flat"
					icon-pack="feather"
					icon="icon-file-plus"
					@click="displayLinkPopup(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="task.document_count > 0">
			<vx-tooltip text="Voir les documents partagés" position="top">
				<vs-button
					size="large"
					color="rgba(243, 222, 239, 0.4)"
					text-color="purple"
					type="flat"
					icon-pack="feather"
					icon="icon-file-text"
					@click="displayLinkPopup(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="$acl.check('sadmin') && !task.mission_id">
			<vx-tooltip text="Effacer" position="top">
				<vs-button
					size="large"
					color="danger"
					type="flat"
					icon-pack="feather"
					icon="icon-trash-2"
					@click="deleteTask(task)"
				></vs-button>
			</vx-tooltip>
		</vs-td>
		<vs-td v-if="$acl.check('sadmin') && task.mission_id"></vs-td>
	</vs-tr>
</template>
        </vs-table>
		<vs-popup
			:active.sync="showConfirmationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du document ?"
		>
			<div class="vx-row" style="z-index: 100 !important;">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup :title="getSocietyName(society_id) + ', Contrat N°' + contract_id + ' : ' + getMissionProduct(mission_id)" :active.sync="showLinkPopup">
			<ShareLinkPopup
				v-model="showLinkPopup"
				:apiUrl="apiUrl"
				:society_id="society_id"
				:mission_id="mission_id"
				:task_id="task_id"
				:contract_id="contract_id"
				@open-confirmation="confirmation(arguments)"
				ref="shareLink"
			/>
		</vs-popup>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";

import Mission from "@/entities/Mission";
import store from "@/store/store";
import ShareLinkPopup from "@/components/popups/ShareLinkPopup";

import SliderWith3btn from "@/components/widgets/SliderWith3btn";

export default {
	name: "TaskHistoryPopup",
	props: {
		tasks: Array,
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
		contractId: Number,
		societyName: String
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		ShareLinkPopup,
		SliderWith3btn
	},
	created(){
		console.log("TASSSS",this.$props.tasks )
		this.getProductDescriptionByMissionIdSet(this.$props.tasks);
		this.allTasks = JSON.parse(JSON.stringify(this.$props.tasks));
		this.allTasks.sort(
			(a, b) => {
				// Use toUpperCase() to ignore character casing
				const dateA = a.finished_date ? new Date(a.finished_date.substring(0, 10)) : null;
				const dateB = b.finished_date ? new Date(b.finished_date.substring(0, 10)) : null;

				let comparison = 0;
				if(!dateA && !dateB) return 0;
				if(!dateA && dateB) return 1;
				if(dateA && !dateB) return -1;
				if(dateA < dateB) {
					comparison = 1;
				}
				else if(dateA > dateB) {
					comparison = -1;
				}
				return comparison;
			}
		);
		if(this.contractId){
			for(let i = 0; i < this.allTasks.length; i++){
				if(this.allTasks[i].contract_id !== this.contractId) delete this.allTasks[i];
			}
		}
		this.allTasks = this.allTasks.filter(notNull => notNull);
		this.allTasks = this.allTasks.reverse();
		this.displayedTasks = JSON.parse(JSON.stringify(this.allTasks));

		this.allMissions = [];
		if(this.tasks.length > 0){
			if(this.$props.contractId){
				Mission.getMissionsForContract(this.$props.contractId, (err, res) => {
					for(let task of this.displayedTasks){
						task.number = res.indexOf(res.filter(mission => mission.id == task.mission_id)[0]) + 1;
						this.refreshTable++;
					}

				});
			}
			else{
				Mission.getMissionsForContract(this.$props.tasks[0].contract_id, (err, res) => {
					for(let task of this.displayedTasks){
						task.number = res.indexOf(res.filter(mission => mission.id == task.mission_id)[0]) + 1;
						this.refreshTable++;
					}
				});
			}
		}
		this.displayedTasks = this.displayedTasks.sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date));
	},
	computed: {
		societies: () => {
			return store.state.societies;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	watch: {
		society: function(data) {
			this.getAllRelatedUser(data.id);
			this.getCommercialSociety(data.commercial_id);
		},
		/*
		 * contractNumberFilter: function() {
		 * if(this.contractNumberFilter == "") {
		 * this.contractNumberFilterOn = false
		 * }else{
		 * this.contractNumberFilterOn = true
		 * }
		 * //console.log("contractNumberFilter")
		 * this.displayedTasks = this.filterTasks(this.allTasks) //A CHANGER
		 * },
		 */
		statusFilter: function() {
			if(this.statusFilter == "") {
				this.statusFilterOn = false;
			}
			else{
				this.statusFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.allTasks); //A CHANGER; //A CHANGER
		},
		taskFilter: function() {
			if(this.taskFilter == "") {
				this.taskFilterOn = false;
			}
			else{
				this.taskFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.allTasks); //A CHANGER
		},
		popupActive: function(){
			this.isPopupActive = this.$props.popupActive;
			//console.log("this.popupActive", this.popupActive);
		},
		isPopupActive: function(){
			this.$emit("update:popupActive", this.isPopupActive);
		}
	},

	data() {
		return {
			missionsProduct: [],
			allTasks: [],
			displayedTasks: [],
			isPopupActive: this.$props.popupActive,
			contractNumberFilter: null,
			statusFilter: [],
			statusFilterOn: false,
			taskFilter: null,
			//contractNumberFilterOn: false,
			taskFilterOn: false,
			taskStatusOptions: [
				{text: "À\u00a0faire", value: 0},
				{text: "Fait", value: 1},
				{text: "Annulé", value: 2}
			],
			showLinkPopup: false,
			society_id: null,
			task_id: null,
			contract_id: null,
			mission_id: null,
			showConfirmationPopup: false,
			docId: "",
			refreshTable: 0
		};
	},

	methods: {
		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		accept(){
			this.deleteDoc(this.docId);
			this.showConfirmationPopup = false;
		},
		confirmation(param){
			this.showConfirmationPopup = param[0];
			this.docId = param[1];
		},

		decline(){
			this.docId = "";
			this.showConfirmationPopup = false;
		},

		deleteDoc(docId){
			this.$http.delete(this.apiUrl + "shared_document/delete/document/" + docId)
				.then(() => {
					this.$refs.shareLink.refreshList(this.task_id);
				}
				);
		},
		getSocietyName(society_id){
			let society_name = "";
			let foundSociety = this.societies.findIndex(row => row.id == society_id);
			if(foundSociety >= 0){
				society_name = this.societies[foundSociety].name;
			}
			return society_name;
		},
		displayLinkPopup(task) {
			this.showLinkPopup == true ? this.showLinkPopup = false : this.showLinkPopup = true;

			this.society_id = task.contract_society_id;
			this.task_id = task.id;
			this.contract_id = task.contract_id;
			this.mission_id = task.mission_id;
			this.showLinkPopup = true;
		},
		/**
		 * Get all Mission IDs for all tasks
		 * @param {Object} tasks - Task List Object
		 * @return - Array of contract IDs
		 */
		getAllTasksMissionIds(tasks){
			let mission_ids = [];
			for(let task of tasks){
				if(mission_ids.length > 0){
					if(task.mission_id){
						if(!mission_ids.includes(task.mission_id)){
							mission_ids.push(task.mission_id);
						}
					}
				}
				else{
					if(task.mission_id){
						mission_ids.push(task.mission_id);
					}
				}
			}
			return mission_ids;
		},

		/**
		 * Fetch Missions descriptions by mission ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getProductDescriptionByMissionIdSet(tasks){
			let string_mission_ids = JSON.stringify(this.getAllTasksMissionIds(tasks));
			//console.log("string_contract_ids", string_mission_ids);
			this.$http
				.get(this.apiUrl + "mission/allpdesc/", {
					params: {
						missionids: string_mission_ids
					}
				})
				.then(res => {
					//console.log(res.data);
					this.missionsProduct = res.data;
				})
				.catch(err => {
					//console.log(err);
				});
		},

		/**
		 * Get Contract Type from list by Contract ID
		 * @param {Number} contractId - ID of the contract to get category for
		 * @return {Number} - Contract's category ID
		 */
		getMissionProduct(missionId){
			for(let mission of this.missionsProduct){
				if(mission.id == missionId){
					return mission.perform;
				}
			}
			return " ";
		},
		/**
		 * Update changed task
		 * @param {Object}
		 */
		updateTask(task, task_state){
			//console.log("task", task);

			let today = new Date(Date.now());
			today = today.toISOString();
			/*
			 * today = today.substring(0,10)
			 * today = today + " 02:00:00"
			 */

			let re = new RegExp("([T|Z])", "g");
			let creation_date = task.creation_date.replace(re, " ");
			today = today.replace(re, " ");
			let finished_date = task.archivate ? today : null;

			this.$http.post(this.apiUrl + "task/edit/" + task.id, {
				commentary: task.commentary,
				link: task.link,
				status: task.status,
				creation_date: creation_date,
				finished_date: finished_date,
				recurrence: task.recurrence,
				frequency: task.frequency,
				archivate: task_state,
				contract_id: task.contract_id,
				contract_society_id: task.contract_society_id,
				mission_id: task.mission_id,
			}).then(res => {
				if(!task.recurrence || task.recurrence == 0){
					let mission_status = 1;
					if(task_state == 1){
						mission_status = 7;
					}
					else if(task_state == 0 || task_state == 2){
						mission_status = 1;
					}
					this.$http.post(this.apiUrl + "mission/editarch", {
						status: mission_status,
						contract_id: task.contract_id,
						id: task.mission_id,
					}).then(res => {
						this.$vs.notify({title: "Succès", text: "Tâche modifiée avec succès."});
						store.dispatch("getAllTasks");
						this.$emit("refresh-task", [task, task_state]);
					}).catch(err => {
						//console.log(err);
						this.$vs.notify({title: "Echec", text: "La tâche n'a pas été modifiée."});
					});
				}
				else{
					this.$vs.notify({title: "Succès", text: "Tâche modifiée avec succès."});
					//this.$emit("update-task");
					store.dispatch("getAllTasks");
					this.$emit("refresh-task");
				}
				task.archivate = task_state;
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "La tâche n'a pas été ajoutée."});
			});
		},

		/**
		 * Delete the contact passed in argument
		 * @param {Number} contactId - Contact ID to delete
		 */
		deleteTask(task){
			this.$http.delete(this.apiUrl + "task/delete/" + task.id.toString())
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Tâche effacée avec succès."
					});
					// Refresh List
					store.dispatch("getAllTasks");
					for(let i = 0; i < this.displayedTasks.length; i++){
						if(this.displayedTasks[i].id == task.id) this.displayedTasks.splice(i, 1);
					}
					this.$forceUpdate();
				})
				.catch(err => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "La tâche n'a pas été effacée."
					});
				});
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			if(this.taskFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered tasks
		 * @param {String} taskFilter - Id of the mission product associated to the task
		 * @param {String} contractNumberFilter - Contract Number in String format can be partial
		 * @return {List} - Societies' list filtered
		 */
		filterTasks(tasks){
			let tasksList = [];

			let searchKeyList = {};
			this.statusFilterOn ? searchKeyList["statusFilter"] = this.statusFilter : false;
			this.taskFilterOn ? searchKeyList["taskFilter"] = this.taskFilter : false;
			//this.contractNumberFilterOn ? searchKeyList["contractNumberFilter"] = this.contractNumberFilter.toString()  : false;

			for(let taskToFilter of tasks){
				let taskSearchKeyList = {};
				//this.contractNumberFilterOn ? taskSearchKeyList["contractNumberFilter"] = taskToFilter.contract_id.toString() : false;
				this.taskFilterOn ? taskSearchKeyList["taskFilter"] = taskToFilter.mission_id : false; // ADAPTER POUR RECUPERER LA LISTE D'AM LIEE AU CONTRAT DE LA TACHE
				this.statusFilterOn ? taskSearchKeyList["statusFilter"] = taskToFilter.archivate : false; // ADAPTER POUR RECUPERER LA LISTE D'AM LIEE AU CONTRAT DE LA TACHE

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */

					if(key == "statusFilter"){
						if(!searchKeyList[key].includes(taskSearchKeyList[key])){
							check = false;
							break;
						}
					}
					else{
						if(typeof searchKeyList[key] == "string"){
							if(typeof taskSearchKeyList[key] == "string"){
								if(!taskSearchKeyList[key].includes(searchKeyList[key])){
									check = false;
									break;
								}
							}
							else if(typeof taskSearchKeyList[key] == "object"){
							////console.log("Array")
								let checkLoop = false;
								for(let value of taskSearchKeyList[key]){
									let service_name = this.getServiceIdToName(value).toLowerCase();
									/*
									 * //console.log(service_name)
									 * //console.log(searchKeyList[key])
									 */
									if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
										checkLoop = true;
									}
								}
								if(!checkLoop){
									check = checkLoop;
									break;
								}
							}
						}
						else{
							if(Array.isArray(taskSearchKeyList[key])){
								//console.log("isArray");
								//console.log(taskSearchKeyList[key]);
								//console.log(searchKeyList[key]);
								if(!taskSearchKeyList[key].includes(searchKeyList[key])){
									check = false;
									break;
								}
							}
							else{
								if(taskSearchKeyList[key] != searchKeyList[key]){
									check = false;
									break;
								}
							}
						}
					 }
				}

				if(check) tasksList.push(taskToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */

			if(this.statusFilter.length > 1) tasksList = tasksList.filter(task => this.statusFilter.includes(task.archivate));

			return tasksList;
		},
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.right-elem {
  justify-content: flex-end;
}

.bg-color {
  background: #35e9fd !important;
}

.t-border {
  border-top: 1px solid grey;
}

.l-border {
  border-left: 1px solid grey;
}

.title {
  font-weight: 600;
  font-size: 2em;
}

.f-color {
  color: black;
}

.center-align {
  display: flex;
  align-items: center;
}

.no-width-limit{
  width: unset;
}
</style>
